import * as organizationsOrganizationUnitsCommands from '@Organizations/OrganizationUnits/commands-vue-composables'
import * as organizationsOrganizationUnitsQueries from '@Organizations/OrganizationUnits/queries-vue-composables'

export function useManageBrandingPage(){
	return {
		useApplyBrandingCommand: organizationsOrganizationUnitsCommands.useApplyBrandingCommandV1,
		useBrandingQuery: organizationsOrganizationUnitsQueries.useBrandingQueryV1,
		useResetBrandingCommand: organizationsOrganizationUnitsCommands.useResetBrandingCommandV1,
	}
}

